import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IMobileLeadForm {
  id?: number;
  component_id?: number;
  status?: boolean;
}

/**
 * Create mobile lead form entry
 */
export async function createMobileLeadForm(payload: Partial<IMobileLeadForm>) {
  try {
    const response = await adminAxios.post(ADMIN_API_ENDPOINTS.MOBILE_LEAD_FORM.CREATE,
      payload
    );
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Update mobile lead form
 */
export async function updateMobileLeadForm(id: number, payload: Partial<IMobileLeadForm>) {
  try {
    const response = await adminAxios.put(ADMIN_API_ENDPOINTS.MOBILE_LEAD_FORM.UPDATE(id),
      payload
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Get mobile lead form by component ID
 */
export async function getMobileLeadFormByComponentId(componentId: number) {
  try {
    const response = await adminAxios.get(ADMIN_API_ENDPOINTS.MOBILE_LEAD_FORM.GET_BY_COMPONENT_ID(componentId)
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError.response?.status === 404) {
      return null;
    }
    const errorResponse = handleApiError(axiosError);
    return errorResponse ? errorResponse : null;
  }
}

/**
 * Delete mobile lead form
 */
export async function deleteMobileLeadForm(id: number) {
  try {
    const response = await adminAxios.delete(ADMIN_API_ENDPOINTS.MOBILE_LEAD_FORM.UPDATE(id)
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

